import type { CatalogTree } from '../types';

export const home = {
  waiting: {
    title: 'Personel bekleyen',
    count: 'Bekleyen konuşma',
    oldest: 'En uzun bekleme: {duration}',
    none: 'Bekleyen konuşma yok',
    open: 'Bekleyenleri aç',
  },
  assistant: {
    title: 'Asistan',
    answering: 'Asistan yanıtlıyor',
    paused: 'Asistan duraklatıldı',
    pauseAll: 'Tüm kanallarda duraklat',
  },
  period: {
    today: 'Bugün',
    last7Days: 'Son 7 gün',
    conversations: 'Konuşma',
    aiHandled: 'Asistan yanıtladı',
    staffHandled: 'Personele aktarıldı',
    medianFirstReply: 'İlk yanıt (medyan)',
    salesConfirmed: 'Satış (kesin)',
    salesLikely: 'Satış (olası)',
    sales: '{count} · {amount}',
  },
  usage: {
    title: 'Yapay zekâ kullanımı',
    bar: 'Bu dönemki kullanım',
    percent: '%{percent}',
    unlimited: 'Sınırsız',
    over: 'Sınır aşıldı',
    open: 'Kullanım ayrıntıları',
  },
  alerts: {
    title: 'Uyarılar',
    open: 'Aç',
  },
  empty: 'Henüz konuşma yok. Bir kanal bağlayın.',
  push: {
    text: 'Bildirimleri açın: personel bekleyen konuşmaları anında görün.',
    enable: 'Bildirimleri aç',
  },
} as const satisfies CatalogTree;
